import { jsx as _jsx } from "react/jsx-runtime";
import { pluralReadableTypeName, readableTypeName } from '@iotv/core-services';
import { Stack, ThemeProvider } from '@mui/material';
import { objectCardTheme } from '../../v2/components/generic/ObjectView/cosmetics/objectCardTheme';
import { TabularDataGrid } from '../factories/DataGrid';
import { ItemLink } from './ItemLinkList';
const NodeEdgeMapperListTable = ({ mapper, excludeObjectTypeIds, includeGroups, extractionFnMap, }) => {
    const blackListFilter = (typeId) => {
        return !excludeObjectTypeIds || !excludeObjectTypeIds.includes(typeId);
    };
    const containedTypeIds = Object.keys(mapper.skMapped).reduce((a, key) => {
        const objectTypeId = key.split(':')[0];
        if (!a.includes(objectTypeId) && (includeGroups ? true : objectTypeId !== 'Group')) {
            a.push(objectTypeId);
        }
        return a;
    }, []);
    const processedContainedTypeIds = containedTypeIds.filter(blackListFilter).sort((a, b) => a.localeCompare(b));
    const containedSupportedTypes = mapper
        .getContainedItems()
        .filter((n) => n.type === 'Group')
        .reduce((a, group) => {
        const supportedType = group.supportedType;
        if (!a.includes(supportedType)) {
            a.push(supportedType);
        }
        return a;
    }, []);
    const rows = [
        ...processedContainedTypeIds.map((containedTypeId) => {
            if (extractionFnMap && extractionFnMap[containedTypeId]) {
                return { id: containedTypeId, type: readableTypeName(containedTypeId), items: extractionFnMap[containedTypeId](mapper) };
            }
            else {
                return { id: containedTypeId, type: readableTypeName(containedTypeId), items: mapper.getNodesOfType(containedTypeId) };
            }
        }),
        ...(excludeObjectTypeIds?.includes('Group')
            ? []
            : containedSupportedTypes.filter(blackListFilter).map((supportedType) => {
                return {
                    id: `Group_${supportedType}`,
                    type: `${readableTypeName(supportedType)} ${pluralReadableTypeName('Group')}`,
                    items: mapper.getNodesOfType('Group').filter((n) => n.supportedType === supportedType),
                };
            })),
    ];
    const linkerlizer = (p) => {
        const items = p.row.items;
        return (_jsx(Stack, { height: '100%', direction: 'row', alignItems: 'center', gap: 1, sx: { marginInline: -1, paddingInline: 1, overflowY: 'clip', overflowX: 'auto', scrollbarWidth: 'thin' }, children: items.map((item) => (_jsx(Stack, { children: _jsx(ItemLink, { item, underscoreLinks: true }) }, item.sk))) }));
    };
    return rows.length > 0 ? (_jsx(ThemeProvider, { theme: objectCardTheme, children: _jsx(TabularDataGrid, { columns: [
                { field: 'type', flex: 3, cellClassName: 'dark' },
                { field: 'items', flex: 8, renderCell: linkerlizer },
            ],
            rows,
            rowHeight: 36,
            hideFooter: true,
            columnHeaderHeight: 0,
            style: { fontSize: 'inherit' },
            sx: { [`& .MuiDataGrid-row--borderBottom .MuiDataGrid-columnHeader`]: { borderBottom: 'none' } } }) })) : null;
};
export default NodeEdgeMapperListTable;
